export const boxesMainCategoryKey = "boxes";
export const boxesSubCategoryKey = "boxes/trolley";
export const boxigoBoxesSubCategoryKey = "boxigo_carton_box";